var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 51,
    viewBox: "0 0 254 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.8 0.955078H246.02C250.061 0.955078 253.336 4.51354 253.336 8.90313V42.6824C253.336 47.0719 250.061 50.6304 246.02 50.6304H7.30899C3.26803 50.6304 -0.0078125 47.0719 -0.0078125 42.6824V8.90313C-0.0078125 4.51354 3.26803 0.955078 7.30899 0.955078H81.909V0.955078",
    stroke: "black",
    strokeWidth: 0.993506,
    strokeLinecap: "round",
    strokeDasharray: 3.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/Path.95432cb8c9591ddc2ab4c6a7032251dd.svg";
export { ForwardRef as ReactComponent };